import { getLocalizedString } from "@grandvisionhq/utils";
const mapAppliedDiscounts = (appliedDiscounts, intl) => {
  const mappedDiscounts = appliedDiscounts?.map((discount) => ({
    label: getLocalizedString(discount.details?.name, intl.locale),
    value: discount.amount,
    type: discount.type
  }));
  return mappedDiscounts;
};
export {
  mapAppliedDiscounts
};
//# sourceMappingURL=map-applied-discounts.js.map
